
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // import useTranslation from 'next-translate/useTranslation';
import { Breadcrumb } from "@components/breadcrumb";
import { CompanyLogo } from "@components/company-logo";
import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { PVC } from "@consts/ppvc";
import type { ICompany } from "@type/company";
import type { IProduct } from "@type/products";
import { getAllPvcByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface ICompanyCard {
    company: ICompany;
    products: IProduct[];
}
const VekaPage: NextPage<ICompanyCard> = ({ products, company }) => {
    const { t } = useTranslation("pvc");
    const { t: tr } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            {
                href: "https://knsokna.pl/pvc/windows/veka",
                hrefLang: "x-default",
            },
            { href: "https://knswindows.com/pvc/windows/veka", hrefLang: "en" },
            { href: "https://knsokna.pl/pvc/windows/veka", hrefLang: "pl" },
            { href: "https://knsfenster.de/pvc/windows/veka", hrefLang: "de" },
            { href: "https://kns-okna.eu/pvc/windows/veka", hrefLang: "cs" },
            { href: "https://knsfinestre.it/pvc/windows/veka", hrefLang: "it" },
            { href: "https://knsfenetres.fr/pvc/windows/veka", hrefLang: "fr" },
            { href: "https://knsokna.eu/pvc/windows/veka", hrefLang: "hu" },
        ]} title={`${t("windows.name")} ${t("windows.veka.title")}`}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <Breadcrumb />
          <h1 className="bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
            {company?.title}
          </h1>
          <CompanyLogo content={company?.content} logo="veka" title={company?.title}/>
          {tr("menu.products")}:
          <br />
          <Products products={products} showId/>
          <hr />
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products, company } = await getAllPvcByParent(PVC.WINDOWS.VEKA[LOCALE as keyof typeof PVC.WINDOWS.VEKA], LOCALE);
    return {
        props: {
            company,
            products,
        },
    };
};
export default VekaPage;

    async function __Next_Translate__getStaticProps__1a19cd2c0a6__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/windows/veka/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c0a6__ as getStaticProps }
  